// extracted by mini-css-extract-plugin
export default {"card":"tSaqIvfu","header":"AKWlLqgw","title":"xQS_DDG1","label":"khccy5pZ","name":"DqfcWefZ","buttons":"KLe1qHFh","form":"kDus8yTC","ant-form-item-label":"VIPKL65c"};